(function($) {
  	var body = $('body');
    var doc = $(document);  

    var iconCart = $('#cartToggle');
    var dropdownCart = $('#dropdown-cart');
    var cartNoItems = dropdownCart.find('.no-items');
    var cartHasItems = dropdownCart.find('.has-items');
    var miniProductList = dropdownCart.find('.mini-products-list');
  
    if ($('.collection-sidebar').length) {
      History.Adapter.bind(window, 'statechange', function() {
        var State = History.getState();

        if (!bourdon.isSidebarAjaxClick) {
          bourdon.sidebarParams();

          var newurl = sidebarCreateUrl();

          bourdon.sidebarGetContent(newurl);
        }

        bourdon.isSidebarAjaxClick = false;
      });
    };
  
    var changeSwatch = function(swatch) {
      swatch.change(function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();

        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    };

    if (window.use_color_swatch) {

      changeSwatch($('.swatch :radio'));

      Shopify.productOptionsMap = {};
      Shopify.quickViewOptionsMap = {};

      Shopify.updateOptionsInSelector = function(selectorIndex, wrapperSlt) {
        
        Shopify.optionsMap = wrapperSlt === '.product' ? Shopify.productOptionsMap : Shopify.quickViewOptionsMap;

        switch (selectorIndex) {
          case 0:
            var key = 'root';
            var selector = $(wrapperSlt + '.single-option-selector:eq(0)');
            break;
          case 1:
            var key = $(wrapperSlt + ' .single-option-selector:eq(0)').val();
            var selector = $(wrapperSlt + ' .single-option-selector:eq(1)');
            break;
          case 2:
            var key = $(wrapperSlt + ' .single-option-selector:eq(0)').val();
            key += ' / ' + $(wrapperSlt + ' .single-option-selector:eq(1)').val();
            var selector = $(wrapperSlt + ' .single-option-selector:eq(2)');
        }

        var initialValue = selector.val();

        selector.empty();

        var availableOptions = Shopify.optionsMap[key];

        if (availableOptions && availableOptions.length) {
          for (var i = 0; i < availableOptions.length; i++) {
            var option = availableOptions[i];

            var newOption = $('<option></option>').val(option).html(option);

            selector.append(newOption);
          }

          $(wrapperSlt + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
            if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
              $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
            }
            else {
              $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
            }
          });

          if ($.inArray(initialValue, availableOptions) !== -1) {
            selector.val(initialValue);
          }
          
          selector.trigger('change');
        };
      };

      Shopify.linkOptionSelectors = function(product, wrapperSlt) {
        // Building our mapping object.
        Shopify.optionsMap = wrapperSlt === '.product' ? Shopify.productOptionsMap : Shopify.quickViewOptionsMap;
        
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];

          if (variant.available) {
            // Gathering values for the 1st drop-down.
            Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];

            Shopify.optionsMap['root'].push(variant.option1);
            Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);

            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
              var key = variant.option1;
              Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
              Shopify.optionsMap[key].push(variant.option2);
              Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }

            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
              var key = variant.option1 + ' / ' + variant.option2;
              Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
              Shopify.optionsMap[key].push(variant.option3);
              Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
          }
        };

        // Update options right away.
        Shopify.updateOptionsInSelector(0, wrapperSlt);

        if (product.options.length > 1) Shopify.updateOptionsInSelector(1, wrapperSlt);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2, wrapperSlt);

        // When there is an update in the first dropdown.
        $(wrapperSlt + " .single-option-selector:eq(0)").change(function() {
          Shopify.updateOptionsInSelector(1, wrapperSlt);
          if (product.options.length === 3) Shopify.updateOptionsInSelector(2, wrapperSlt);
          return true;
        });

        // When there is an update in the second dropdown.
        $(wrapperSlt + " .single-option-selector:eq(1)").change(function() {
          if (product.options.length === 3) Shopify.updateOptionsInSelector(2, wrapperSlt);
          return true;
        });

      };
    };

    $(document).ready(function() {
      bourdon.init();
    });
  
  	
  	// ------   resize
  	$(window).off('resize.mobileMenu').on('resize.mobileMenu', function() {
      	bourdon.initMobileMenu();
    });

    $(window).off('resize.initDropdownSearch').on('resize.initDropdownSearch', function() {
      	bourdon.dropdownSearch();
    });

    $(window).off('resize.initDropdownUser').on('resize.initDropdownUser', function() {
      	bourdon.initDropdownUser();
    });
  
  	if($('.template-index').length) {
      $(window).off('resize.fixedMenuSlideShow').on('resize.fixedMenuSlideShow', function() {
        bourdon.initFixedMenuHasSlideShow();
      });
      
      $(window).off('resize.changeBgMegaMenu').on('resize.changeBgMegaMenu', function() {
        bourdon.addClassChangeMegaMenuBackground();
      });
    };
  
  	if($('.template-collection').length || $('.template-product').length || $('.template-blog').length || $('.template-article').length) {
      var currentWinWidth = $(window).width();
      var resizeTimeout;
      
      $(window).off('resize.sidebarInitToggle').on('resize.sidebarInitToggle', function() {
        clearTimeout(resizeTimeout);
        
        resizeTimeout = setTimeout(function() {
        	if (currentWinWidth !== $(window).width()){
              bourdon.sidebarInitToggle();
              currentWinWidth = $(window).width();
          }
        }, 50);
      });
    };
  
  	if($('.template-product').length) {
      $(window).off('resize.initProductTab').on('resize.initProductTab', function() {
        bourdon.initClickedTextProductTab();
      });
      
      $(window).off('resize.initCloudzoom').on('resize.initCloudzoom', function() {
        bourdon.initCloudzoom();
      });
      
      var winW = $(window).width();

      $(window).off('resize.refreshSlick').on('resize.refreshSlick', function() {
        clearTimeout(bourdon.bourdonTimeout);
        
        bourdon.bourdonTimeout = setTimeout(function() {
          var curW = $(window).width();
          if (curW >= 768 && winW < 768) {

            if($('.product .slider-for').hasClass('slick-initialized') && !$('.product .slider-nav').hasClass('slick-initialized')) {
                $('.product .slider-for').slick('unslick');    
                $('.product .slider-nav').slick('unslick');   
                $('.product .slider-nav').find('.slick-list').removeAttr('style');
                $('.product .slider-nav').find('.slick-track').removeAttr('style');
                $('.product .slider-nav').find('.slick-slide').removeAttr('style');
                $('.product .slider-nav').find('button.slick-arrow').remove();

                bourdon.initProductMoreview();
			};
          }

          winW = curW;  

        }, 300);

      });
    };
  

    var bourdon = {
        bourdonTimeout: null,
        isSidebarAjaxClick: false,
        init: function() {
          	// ---- homePage
          	if($('.template-index').length) {
              this.initFixedMenuHasSlideShow();
            };
          
          	this.addClassChangeMegaMenuBackground();
          	this.initMobileMenu();
          	this.initScrollTop();
          	this.initDropdownCart();
          	this.dropdownSearch();
          	this.initDropdownUser();
          	this.initColorSwatchGrid();
          	this.initResizeImage($('.products-grid .product-image img'));
          	this.closeModal();
          	this.initQuickView();
          	this.initAddToCart();
          
          	//  ---- cartPage
            if($('.template-cart').length) {
              this.initCartQty();
            };
          
          	//  Search Page
          	if($('.template-search').length) {
              this.sidebarMapPaging();
              this.sidebarParams();
              this.initInfiniteScrolling();
            };
          
          	//  ---- Collections and Product Page
            if($('.template-collection').length || $('.template-product').length) {
              this.dropDownSubCategory();
              this.sidebarInitToggle();
            };
          
          	//  ---- collectionsPage
            if($('.template-collection').length) {
              this.sidebarParams();
              this.sidebarMapPaging();
              this.sidebarMapView();
              this.sidebarMapSorting();
              this.initSortby();
              this.initSidebar();
              this.initInfiniteScrolling();
            };
          
          	//  ---- Product Page
            if($('.template-product').length) {
              this.initProductMoreview();
              this.initClickedTextProductTab();
              this.initRelatedProductSlider();
              this.initProductAddToCart();
              this.initCloudzoom();
            };
          
          	//  ---- Blog and Article Page
          	if($('.template-blog').length || $('.template-article').length) {
              this.sidebarInitToggle();
            };
        },
      
        initFixedMenuHasSlideShow: function() {
            if($('.template-index').length) {
				var navbarMobile = $('.template-index .nav-bar-mobile');        
                var slideShow = $('.main-content').children('div.shopify-section').eq(0).children('.home-slideshow');
                var navbarMobileOffsetTop = navbarMobile.offset().top;

                if(window.innerWidth > 991) {

                  if(slideShow.length > 0) {          
                    navbarMobile.css({'position': 'absolute', 'top': navbarMobileOffsetTop, 'left': 0, 'right': 0, 'z-index': 10 });
                    navbarMobile.css({'box-shadow': '', 'margin-bottom': ''});
                  }

                  else {
                    navbarMobile.css({'position': '', 'top': '', 'left': '', 'right': '', 'z-index': '' });
                    navbarMobile.css({ 'box-shadow': 'rgba(0, 0, 0, 0.05) 0px 6px 3px -3px', 'margin-bottom': '15px' });
                  }
                }

                else {
                  navbarMobile.css({'position': '', 'top': '', 'left': '', 'right': '', 'z-index': '' });
                  navbarMobile.css({'box-shadow': 'rgba(0, 0, 0, 0.05) 0 6px 3px -3px', 'margin-bottom': '15px' });
                };
            };
        },
      
      	initMobileMenu: function() {
          	// ----- init language && currency
        	if ($('.header-mobile').is(':visible')) {
              if(window.multi_lang) {
                $('.lang-block').appendTo(jQuery('.opt-area'));
              }

              if(window.show_multiple_currencies) {
                $('.currency').appendTo(jQuery('.opt-area'));
              }
            }

            else {
              if(window.multi_lang) {
                $('.lang-block').prependTo(jQuery('.header-panel-bottom'));
              }

              if(window.show_multiple_currencies) {
                $('.currency').prependTo(jQuery('.header-panel-bottom'));
              }
            };

            // ----- Toggle Navigation Mobile
            var iconNav = $('#showLeftPush');

            if(iconNav.is(':visible')) {
              
              iconNav.off('click.toggleNav').on('click.toggleNav', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                if($('.search-results').is(':visible')) {
                  $('.search-results').hide();
                };
                
                if($('#dropdown-cart').is(':visible')) {
                  $('#dropdown-cart').hide();
                };

                iconNav.toggleClass('open');

                body.toggleClass('translate');
                
                if(body.hasClass('translate')) {
                	$('html').css({"overflow": "hidden"});
                    $('html').addClass('overlay-hide');

                    setTimeout(function() {
                      iconNav.css({"position": "fixed"});
                    }, 300);
                }
                
                else {
                	$('html').css({"overflow": ""});
                    $('html').removeClass('overlay-hide');

                    setTimeout(function() {
                      iconNav.css({"position": ""});
                    }, 300);
                };
                
              });                

              doc.off('click.toggleNav').on('click.toggleNav', function(e) {
                if (!$(e.target).closest('.nav-bar-mobile').length && iconNav.hasClass('open')) {
                  iconNav.trigger('click');
                }        
              });

            };

            // Init Dropdown Menu
            if(window.innerWidth < 992) {
              var iconDropdown = $('.site-nav .icon-dropdown');
              var menuMobile = $('.site-nav .dropdown .menu__moblie');

              iconDropdown.off('click.dropdownMenu').on('click.dropdownMenu', function(e) {
                e.preventDefault();
                e.stopPropagation();

                if($(this).hasClass('mobile-toggle-open')) {
                  $(this).parent().next().slideUp(300);
                  $(this).removeClass("mobile-toggle-open");
                }

                else {
                  $(this).parent().next().slideDown(300);
                  $(this).addClass("mobile-toggle-open");
                }
              });
              
              menuMobile.off('click.current').on('click.current', function(e) {
                var isClickOneTime = $(this).attr('is-click-1-time');
                
                if(isClickOneTime !== 'true') {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  $(this).attr('is-click-1-time', 'true');

                  $(this).next().slideDown(300);
                  $(this).children('.icon-dropdown').addClass("mobile-toggle-open");
                };
              });
            }

            else {
              $('.site-nav-dropdown').css({"display": ""});
            };                    	

            if(window.innerWidth > 991 && ('ontouchstart' in document)) {
                var menuMobile = $('.site-nav .dropdown .menu__moblie');

                menuMobile.on('touchstart click', function(e) {
                  
                  var isClickOneTime = $(this).attr('is-click-1-time');
                  menuMobile.removeClass('border');
                  
                  if(isClickOneTime !== 'true') {
                    e.preventDefault();
                    e.stopPropagation();

                    $(this).attr('is-click-1-time', 'true');
                    $(this).addClass('border');
                    
                    $(this).next().show().parent('li.mega-menu').closest('.nav-bar-mobile').css({'background-color': '#fff'});
                    $('.lang-block .selectize-dropdown').hide();
                    $('.currency .selectize-dropdown').hide();
                    $('#dropdown-cart').hide();
                    $('.header-customer-links .customer-links').hide();
                  };
                  
                });
              
                doc.on('touchstart click', function(e) {
                  if (!$(e.target).closest('.nav-bar-mobile').length) {
                    $('.site-nav > li > .site-nav-dropdown').hide().parent('li.mega-menu').closest('.nav-bar-mobile').css({'background-color': ''});
                  } 
                });
            };
        },
      
      	initColorSwatchGrid: function() { 
            $('.item-swatch li label').hover(function(){
              var newImage = $(this).siblings('.hidden').find('a').attr('href');

              $(this).closest('.grid-item').find('.product-grid-image img').attr({ src: newImage }); 
              return false;
            });
        },
      
        initResizeImage: function(image) {
          if (window.product_image_resize) {
            image.fakecrop({
              fill: window.images_size.is_crop,
              widthSelector: ".products-grid .grid-item .product-image",
              ratioWrapper: window.images_size
            });
          };
        },
      
      	initScrollTop: function() {
        	$(window).scroll(function() {
              if ($(this).scrollTop() > 220) {
                $('#back-top').fadeIn(400);
              }

              else {
                $('#back-top').fadeOut(400);
              }
            });

            $('#back-top').off('click.scrollTop').on('click.scrollTop', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              $('html, body').animate({scrollTop: 0}, 400);
              return false;
            });
        },
      
      	showLoading: function() {
          	$('.loading-modal').show();
        },
      
        hideLoading: function() {
			$('.loading-modal').hide();
        },
      
        showModal: function(selector) {
			$(selector).fadeIn(500);
    
            bourdon.bourdonTimeout = setTimeout(function() {
              $(selector).fadeOut(500);
            }, 5000);
        },
      
        closeModal: function() {
			$('.close-modal, .overlay').click(function(e) {
                e.preventDefault();
                e.stopPropagation();

                clearTimeout(bourdon.bourdonTimeout);

                $('.ajax-success-modal').fadeOut(500);
            });
        },
      
        sidebarParams: function() {
			Shopify.queryParams = {};
    
            //get after ?...=> Object {q: "Acme"} 

            if (location.search.length) {
              for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                
                if (aKeyValue.length > 1) {
                  Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
              }
            };
        },
      
        sidebarMapCategories: function() {
			var sidebarLink = $('.sidebar-links a');      
      
            sidebarLink.off('click.activeCategory').on('click.activeCategory', function(e) {
                if($(this).attr('href') !== '/') {
                    e.preventDefault();
                    e.stopPropagation();

                    var self = $(this);
                    var parent = self.parent();

                    if(!$(this).hasClass('active')) {
                      delete Shopify.queryParams.q;
                      delete Shopify.queryParams.constraint;
                      bourdon.sidebarAjaxClick($(this).attr('href'));
                    };

                    sidebarLink.not(self).removeClass('active');
                    $(this).addClass('active'); 

                    if (parent.hasClass('dropdown') && !parent.hasClass('open')) {
                      $('.dropdown.open').removeClass('open');
                      sidebarLink.siblings('.dropdown-cat').hide();
                      self.siblings('.dropdown-cat').show();
                      parent.addClass('open');                  	  
                    };
                };
            });
        },
      	
      	dropDownSubCategory: function() {
        	var iconDropdown = $('.sidebar-links .icon-dropdown');

            iconDropdown.off('click.dropDownSubCategory').on('click.dropDownSubCategory', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var self = $(this);
                var parent = self.parent();

                if(parent.hasClass('open')) {
                  parent.removeClass('open');
                  self.next().hide();
                }
                else {
                  parent.addClass('open');
                  self.next().show();
                }
            });
        },
      
        sidebarMapTagEvents: function() {
        	var sidebarTag = $('.sidebar-tag a:not(".clear"), .sidebar-tag label, .refined .selected-tag');
    
            sidebarTag.off('click.checkedTag').on('click.checkedTag', function(e) {
                  e.preventDefault();
                  e.stopPropagation();

                  var currentTags = [];

                  if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+'); //Array
                  };

                  //one selection or multi selection
                  if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(':checked')) {
                    //remove other selection first
                    var otherTag = $(this).closest('.sidebar-tag, .refined-widgets').find('input:checked');

                    if (otherTag.length) {
                      var tagName = otherTag.val();
                      if (tagName) {
                        var tagPos = currentTags.indexOf(tagName);
                        if (tagPos >= 0) {
                          //remove tag
                          currentTags.splice(tagPos, 1);
                        }
                      }
                    };
                  };

                  var tagName = $(this).prev().val();

                  if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);

                    if (tagPos >= 0) {
                      //tag already existed, remove tag
                      currentTags.splice(tagPos, 1);
                    }
                    else {
                      //tag not existed
                      currentTags.push(tagName);
                    }
                  };

                  if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                  }
                  else {
                    delete Shopify.queryParams.constraint;
                  };

                  bourdon.sidebarAjaxClick();
            });
      	},
      
      	sidebarMapView: function() {
          	var viewAs = $('.view-mode > .view-as');
    
            viewAs.off('click.mapView').on('click.mapView', function(e) {
                e.preventDefault();
                e.stopPropagation();

                if (!$(this).hasClass('active')) {

                  if ($(this).hasClass('list')) {
                    Shopify.queryParams.view = 'list';
                  }
                  else {
                    Shopify.queryParams.view = '';
                  }

                  bourdon.sidebarAjaxClick();

                  $('.view-mode .view-as.active').removeClass('active');
                  $(this).addClass('active');
                }
            });
        },
      
        sidebarMapSorting: function() {
			var sortbyFilter = $('.filter-sortby li span');

            sortbyFilter.off('click.sortBy').on('click.sortBy', function(e) {
              e.preventDefault();
              e.stopPropagation();

              var self = $(this);
              var parent = self.parent();
              var sortbyText = self.text();
              var label = $('.filter-sortby > button span.text');

              if(!parent.hasClass('active')) {
                Shopify.queryParams.sort_by = $(this).attr("data-href");
                bourdon.sidebarAjaxClick();
                label.text(sortbyText);
              }

              sortbyFilter.not(self).parent().removeClass('active');
              self.parent().addClass('active');
              $('.toolbar button.dropdown-toggle').trigger('click', true);
            });
        },
      
        initSortby: function() {
            if (Shopify.queryParams.sort_by) {
              var sortby = Shopify.queryParams.sort_by;
              var sortbyText = $(".filter-sortby span[data-href='" + sortby + "']").text();
              
              $('.filter-sortby > button span.text').text(sortbyText);
              $('.filter-sortby li.active').removeClass("active");
              $(".filter-sortby span[data-href='" + sortby + "']").parent().addClass("active");
            }
          
            else {
              var sortbyText = $(".filter-sortby .dropdown-menu .active").text();
              
              $('.filter-sortby > button span.text').text(sortbyText);
            }
        },
      
      	sidebarMapPaging: function() {
            body.off('click.initMapPaging', '.pagination-page a').on('click.initMapPaging', '.pagination-page a', function(e) {
              e.preventDefault();
              e.stopPropagation();

              var page = $(this).attr("href").match(/page=\d+/g);
              
              if (page) {
                Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                
                if (Shopify.queryParams.page) {
                    var newurl = bourdon.sidebarCreateUrl();

                    bourdon.isSidebarAjaxClick = true;

                    History.pushState({
                      param: Shopify.queryParams
                    }, newurl, newurl);

                    bourdon.sidebarGetContent(newurl);
                  	
                  	var top = $('.block-row > div > .toolbar, .search-page').offset().top;
	
                    $('body,html').animate({
                      scrollTop: top
                    }, 600);
                };
              };

            });
        },
      
        sidebarMapClear: function() {
          	var sidebarTag = $('.sidebar-tag');
          
          	sidebarTag.each(function() {
                var sidebarTag = $(this);
              
                if (sidebarTag.find("input:checked").length) {
                  //has active tag
                  sidebarTag.find(".clear").show().click(function(e) {
                    e.preventDefault();
              		e.stopPropagation();
                    
                    var currentTags = [];
                    
                    if (Shopify.queryParams.constraint) {
                      currentTags = Shopify.queryParams.constraint.split('+');
                    };
                    
                    sidebarTag.find("input:checked").each(function() {
                      var selectedTag = $(this);
                      var tagName = selectedTag.val();
                      
                      if (tagName) {
                        var tagPos = currentTags.indexOf(tagName);
                        if (tagPos >= 0) {
                          //remove tag
                          currentTags.splice(tagPos, 1);
                        };
                      };
                    });
                    
                    if (currentTags.length) {
                      Shopify.queryParams.constraint = currentTags.join('+');
                    }
                    else {
                      delete Shopify.queryParams.constraint;
                    };
                    
                    bourdon.sidebarAjaxClick();
                    
                  });
                }
            });
        },
      
        sidebarMapClearAll: function() {
          	var clearAllElm = $('.refined-widgets a.clear-all');
          
            clearAllElm.off('click.clearAllTags').on('click.clearAllTags', function(e) {
              e.preventDefault();
              e.stopPropagation();

              delete Shopify.queryParams.constraint;
              delete Shopify.queryParams.q;
              
              bourdon.sidebarAjaxClick();
            });
        },
      
        sidebarInitToggle: function() {
			var sidebarLabel = $('.col-sidebar .sidebar-label');
    
            if(sidebarLabel.is(':visible')) {
              sidebarLabel.off('click.showSidebar').on('click.showSidebar', function() {
                $('.sidebar').toggleClass('open').slideToggle();
                
                var top = $(this).offset().top;
                
                $('body,html').animate({
                  scrollTop: top
                }, 600)
              });
            };

            if(window.innerWidth < 992) {
              var sidebar = $('.sidebar');
              var widgetTitle = sidebar.find('.widget-title');
              
              widgetTitle.removeClass('open');            
            }
            else {
              var sidebar = $('.sidebar-tag');
              var widgetTitle = sidebar.find('.widget-title');
            };

            widgetTitle.off('click.slideToogle').on('click.slideToogle', function() { 
                clearTimeout(bourdon.bourdonTimeout);

                bourdon.bourdonTimeout = setTimeout(function() {

                  $('.widget-product .products-grid').slick('unslick');    
                  $('.widget-product .products-grid').find('.slick-list').removeAttr('style');

                  if(!$('.widget-product .products-grid').hasClass('slick-initialized')) {

                    $('.widget-product .products-grid').slick({
                      dots: false,
                      slidesToScroll: 1,
                      verticalSwiping: false,
                      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" style="enable-background:new 0 0 17 33;" xml:space="preserve"><title>svg-arrow-next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
                      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title>svg-arrow-prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
                      responsive: [
                        {
                          breakpoint: 992,
                          settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                          }
                        },
                        {
                          breakpoint: 768,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                          }
                        },
                        {
                          breakpoint: 480,
                          settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                          }
                        }
                      ]
                    });
                  };
                  
                }, 50);

                $(this).toggleClass('open');
                $(this).next().slideToggle();
            });
        },
      
      	sidebarAjaxClick: function(baseLink) {
          	delete Shopify.queryParams.page;
    
            var newurl = bourdon.sidebarCreateUrl(baseLink);

            bourdon.isSidebarAjaxClick = true;

            History.pushState({
              param: Shopify.queryParams
            }, newurl, newurl);

            bourdon.sidebarGetContent(newurl);
        },
      
        sidebarCreateUrl: function(baseLink) {
			var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
    
            if (baseLink) {
              if (newQuery != "")
                return baseLink + "?" + newQuery;
              else
                return baseLink;
            }
            return location.pathname + "?" + newQuery;
        },
      
        initInfiniteScrolling: function() {
          var infiniteScrolling = $('.infinite-scrolling');

          if(infiniteScrolling.length) {
            body.off('click.initInfiniteScrolling', '.infinite-scrolling a').on('click.initInfiniteScrolling', '.infinite-scrolling a', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              if (!$(this).hasClass('disabled')) {
                bourdon.doInfiniteScrolling();
              };
            });
          };
        },
      
        doInfiniteScrolling: function() {
			var currentList = $('.block-row .products-grid');
          
            if (!currentList.length) {
              currentList = $('.block-row .product-list');
            };
          
            if (currentList) {
              var showMoreButton = $('.infinite-scrolling a');

              $.ajax({
                type: 'GET',
                url: showMoreButton.attr("href"),
                
                beforeSend: function() {
                  bourdon.showLoading();
                },
                
                success: function(data) {
                  bourdon.hideLoading();
                  
                  var products = $(data).find(".block-row .products-grid");
                  
                  if (!products.length) {
                    products = $(data).find(".block-row .product-list");
                  };
                  
                  if (products.length) {
                    if (products.hasClass('products-grid')) {
                      bourdon.initResizeImage(products.children().find('img'));
                    };
                    
                    currentList.append(products.children());
                    bourdon.translateBlock('.main-content');
                    
                    //get link of Show more
                    if ($(data).find('.infinite-scrolling').length > 0) {
                      showMoreButton.attr('href', $(data).find('.infinite-scrolling a').attr('href'));
                    }
                    else {
                      //no more products
                      var noMoreText = window.inventory_text.no_more_product;
                      
                      if (translator.isLang2()) 
                      noMoreText = window.lang2.collections.general.no_more_product;
                      
                      showMoreButton.html(noMoreText).addClass('disabled');
                    };

                    //currency
                    if (bourdon.checkNeedToConvertCurrency()) {
                      Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), 'span.money', 'money_format');
                    };

                    bourdon.initColorSwatchGrid();

                    //product review
                    if ($(".shopify-product-reviews-badge").length > 0) {
                      return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                    };
                  }
                },
                
                error: function(xhr, text) {
                  bourdon.hideLoading();
                  $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                  bourdon.showModal('.ajax-error-modal');
                },
                dataType: "html"
              });
            }
        },
       
        sidebarGetContent: function(newurl) {
          	$.ajax({
                type: 'get',
                url: newurl,
              
                beforeSend: function() {
                  bourdon.showLoading();
                },
              
                success: function(data) {
                  bourdon.sidebarMapData(data);
                  bourdon.translateBlock('.main-content');
                  bourdon.sidebarMapTagEvents();
                  bourdon.sidebarMapPaging();
                  bourdon.sidebarInitToggle();
                  bourdon.sidebarMapClear();
                  bourdon.sidebarMapClearAll();
                  bourdon.hideLoading();
                  
                  if(window.innerWidth < 992 && $('.col-sidebar .sidebar-label').is(':visible')) {
                    $('.sidebar').removeClass('open').slideUp(600);
                  }
                  else {
                  	$('.sidebar').css({'display': ''});
                  };
                },
              
                error: function(xhr, text) {
                  bourdon.hideLoading();
                  $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                  bourdon.showModal('.ajax-error-modal');
                }
              });
        },
      
      	sidebarMapData: function(data) {
        	var currentList = $(".col-main .products-grid");
    
            if (currentList.length == 0) {
              currentList = $(".col-main .product-list");
            };

            var productList = $(data).find(".col-main .products-grid");

            if (productList.length == 0) {
              productList = $(data).find(".col-main .product-list");
            };

            if (productList.length > 0 && productList.hasClass("products-grid")) {
              bourdon.initResizeImage(productList.find('img'));
            };

            currentList.replaceWith(productList);

            //convert currency
            if (bourdon.checkNeedToConvertCurrency()) {
              Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '.col-main span.money', 'money_format');
            };
          

            //replace paging
            if ($(".padding").length > 0) {
              $(".padding").replaceWith($(data).find(".padding"));
            }

            else {
              $(".block-row.col-main").append($(data).find(".padding"));
            };
          

            //replace title & description
            var currentHeader = $('.page-header');
            var dataHeader = $(data).find('.page-header');

            if (currentHeader.find("h2").text() != dataHeader.find("h2").text()) {
              currentHeader.find("h2").replaceWith(dataHeader.find("h2"));

              var currentDes = $(".collection-des");
              var dataDes = $(data).find(".collection-des");

              if (currentDes.find(".rte").length) {
                if (dataDes.find(".rte").length) {
                  currentDes.html(dataDes.find(".rte"));
                } else {
                  currentDes.find(".rte").hide();
                }
              }
              else {
                currentDes.html(dataDes.find(".rte"));
              };

              var currentImg = $(".collection-img");
              var dataImg = $(data).find(".collection-img");
              
              if (currentImg.find("p").length) {
                if (dataImg.find("p").length) {
                  currentImg.html(dataImg.find("p"));
                } else {
                  currentImg.find("p").hide();
                }
              }
              else {
                currentImg.html(dataImg.find("p"));
              }
            };
          
            //replace refined
            $('.refined-widgets').replaceWith($(data).find(".refined-widgets"));

            //replace tags
            $(".sidebar-block").replaceWith($(data).find(".sidebar-block"));

            // breadcrumb
            $(".breadcrumb .bd-title").replaceWith($(data).find(".breadcrumb .bd-title"));

            bourdon.initColorSwatchGrid();
          
            //product review
            if ($(".shopify-product-reviews-badge").length > 0) {
              return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            };
        },
      
        sidebarMapEvents: function() {
            bourdon.sidebarMapCategories();
            bourdon.sidebarMapTagEvents();
            bourdon.sidebarMapView();
            bourdon.sidebarMapSorting();
        },
      
        initSidebar: function() {
			if ($('.collection-sidebar').length) {
              bourdon.sidebarMapCategories();
              bourdon.sidebarMapTagEvents();
              bourdon.sidebarMapClear();
              bourdon.sidebarMapClearAll();
              bourdon.sidebarInitToggle();
            };
        },
      
        checkNeedToConvertCurrency: function() {
			return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
        },
      
        translateBlock: function(blockSelector) {
			if (window.multi_lang && translator.isLang2()) {
              translator.doTranslate(blockSelector);
            }
        },
      
        translateText: function(str) {
			if (!window.multi_lang || str.indexOf("|") < 0)
              return str;

            if (window.multi_lang) {
              var textArr = str.split("|");

              if (translator.isLang2())
                return textArr[1];
                return textArr[0];
            };
        },
      
      	initProductMoreview: function() {
          if ($('.product .product-img-box').hasClass('horizontal')) {
            bourdon.initHorizontallMoreview($('.product .slider-for'), $('.product .slider-nav'));
          }
          else if ($('.product .product-img-box').hasClass('vertical')) {
            bourdon.initVerticalMoreview($('.product .slider-for'), $('.product .slider-nav'));
          };
        },
      
        initHorizontallMoreview: function(sliderFor, sliderNav) {
          if (!sliderFor.hasClass('slick-initialized') && !sliderNav.hasClass('slick-initialized')) {
            sliderFor.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              fade: true,
              verticalSwiping: false,
              asNavFor: sliderNav
            });

            sliderNav.slick({
              infinite: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              asNavFor: sliderFor,
              verticalSwiping: false,
              dots: false,
              focusOnSelect: true,
              nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" style="enable-background:new 0 0 17 33;" xml:space="preserve"><title>svg-arrow-next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
              prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title>svg-arrow-prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',

              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {

                  breakpoint: 768,
                  settings: {
                    slidesToShow:4,
                    slidesToScroll: 1
                  }
                },

                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false
                  }
                }
              ]
            });
          };
        },
      
        initVerticalMoreview: function(sliderFor, sliderNav) {
          if (!sliderFor.hasClass('slick-initialized') && !sliderNav.hasClass('slick-initialized')) {
            sliderFor.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              fade: true,
              verticalSwiping: false,
              asNavFor: sliderNav
            });

            sliderNav.slick({
              infinite: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              vertical: true,
              asNavFor: sliderFor,
              verticalSwiping: false,
              dots: false,
              focusOnSelect: true,
              nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" style="enable-background:new 0 0 17 33;" xml:space="preserve"><title>svg-arrow-next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
              prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title>svg-arrow-prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',

              responsive: [
                {

                  breakpoint: 992,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {

                  breakpoint: 768,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                  }
                },
                
                {

                  breakpoint: 520,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },

                {
                  breakpoint: 380,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false
                  }
                }
              ]
            });
          };
        },
      
        initCloudzoom: function() {
          if ($(window).width() >= 992 && $('.zoomContainer').length === 0 && !('ontouchstart' in document)) {
            if ($('img[id|="product-featured-image"]').length) {
              $('img[id|="product-featured-image"]').elevateZoom({
                cursor: 'pointer',
                galleryActiveClass: 'active',
                imageCrossfade: true,
                scrollZoom: true,
                
                onImageSwapComplete: function() {
                  $(".zoomWrapper div").hide();
                },
                
                loadingIcon: window.loading_url
              });
              
              $(".fancybox").fancybox();
            }
          }
          else if ($(window).width() < 992 && $('.zoomContainer').length >= 1 && ('ontouchstart' in document)) {                       
            var images = $('.slick-current img[id|="product-featured-image"]');
            images.off('touchmove');
            $.removeData(images, 'elevateZoom');

            $('.zoomContainer').remove();
          }
          
          else if($(window).width() < 992 || ($(window).width() >= 992 && ('ontouchstart' in document))) {
          	$(".fancybox").fancybox();
          };
          
          $('.slick-current img[id|="product-featured-image"]').hover(function() {
            if($('.zoomContainer').length >= 1) {
              if($('.search-results').is(':visible')) {
                $('.search-results').hide();
              };
            }
          });
        },
      
      	initClickedTextProductTab: function() {
          if($('.panel-group .nav-tabs').length && $('.panel-group .nav-tabs').is(':visible') && window.innerWidth > 991) {

            $('.nav-tabs > li > a').off('click').on('click', function() {
              $(this).tab('show');
            });
          }
        },
      
      	initRelatedProductSlider: function() {
        	var relatedProduct = $('.related-products');
            var productGrid = relatedProduct.find('.products-grid');

            if(relatedProduct.length) {
                productGrid.slick({
                  infinite: true,
                  speed: 500,
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" style="enable-background:new 0 0 17 33;" xml:space="preserve"><title>svg-arrow-next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
                  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title>svg-arrow-prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
                  responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 992,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                      }
                    },

                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                      }
                    }
                  ]
                });
            };
        },
      
        initCartQty: function() {
			var button = $('.cart-list .quantity .button');
    
            button.off('click.changeQuantity').on('click.changeQuantity', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var oldValue = $(this).siblings('input.qty').val(),
                    newVal = 1;

                if($(this).hasClass('inc')) {
                  newVal = parseInt(oldValue) + 1;
                }
                else if(oldValue > 1) {
                  newVal = parseInt(oldValue) - 1;
                }

                $(this).siblings('input.qty').val(newVal);
            });
        },
      
      	checkItemsInDropdownCart: function() {
        	if(miniProductList.children().length) {
                cartHasItems.show();
                cartNoItems.hide();
            }
            else {
              cartHasItems.hide();
              cartNoItems.show();
            }
        },
      
      	clickDropdownCart: function() {
        	iconCart.off('click.toogleDropdownCart').on('click.toogleDropdownCart', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              if($('.search-results').is(':visible')) {
              	$('.search-results').hide();
              };

              dropdownCart.slideToggle();
            });

            doc.off('click.closeDropdownCart').on('click.closeDropdownCart', function(e) {
              if (!$(e.target).closest('#dropdown-cart').length && dropdownCart.is(':visible')) {
                iconCart.trigger('click');
              }        
            });
        },
      
      	removeItemDropdownCart: function(cart) {
        	var btnRemove = dropdownCart.find('.btn-remove');
    
            btnRemove.off('click.removeCartItem').on('click.removeCartItem', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var productId = $(this).parents('.item').attr('id');
                productId = productId.match(/\d+/g);

                Shopify.removeItem(productId, function(cart) {
                    bourdon.doUpdateDropdownCart(cart);
                });
            });
        },
      
        initDropdownCart: function() {
			if(window.dropdowncart_type == 'click') {
              	bourdon.clickDropdownCart();
            }

            else {
              if(!('ontouchstart' in document)) {
                  iconCart.hover(function() {
                      if($('.search-results').is(':visible')) {
                        $('.search-results').hide();
                      };
                    
                      if($('.selectize-dropdown').is(':visible')) {
                        $('.selectize-dropdown').hide();
                      };
                    
                      if($('.customer-links').is(':visible')) {
                        $('.customer-links').hide();
                      };
                    
                      if (!dropdownCart.is(':visible')) {
                        dropdownCart.slideDown();
                      }                                          
                  });

                  $('.wrapper-top-cart').mouseleave(function() {
                     if (dropdownCart.is(':visible')) {
                       dropdownCart.slideUp();
                     }

                  });

              }

              else {
                  bourdon.clickDropdownCart();
              }
            }

            bourdon.checkItemsInDropdownCart();

            var continueShopping = cartNoItems.find('a');

            continueShopping.off('click.closeDropdownCart').on('click.closeDropdownCart', function(e) {
              e.preventDefault();
              e.stopPropagation();

              dropdownCart.slideUp();	
            });

            bourdon.removeItemDropdownCart();
        },
      
      	doUpdateDropdownCart: function(cart) {
			var template = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"><i class="fa fa-times"></i></a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral"><span class="qtt">{QUANTITY} X</span><span class="price">{PRICE}</span></div></div></li>';

            $('#cartCount').text(cart.item_count);

            dropdownCart.find('.summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));

            miniProductList.html('');

            if (cart.item_count > 0) {
              for (var i = 0; i < cart.items.length; i++) {
                var item = template;

                item = item.replace(/\{ID\}/g, cart.items[i].id);
                item = item.replace(/\{URL\}/g, cart.items[i].url);
                item = item.replace(/\{TITLE\}/g, bourdon.translateText(cart.items[i].title));
                item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
                item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, '64x'));
                item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));

                miniProductList.append(item);
              }

              bourdon.removeItemDropdownCart(cart);

              if (bourdon.checkNeedToConvertCurrency()) {
                Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '#dropdown-cart span.money', 'money_format');
              }
            }

            bourdon.checkItemsInDropdownCart();
        },
      
        updateDropdownCart: function() {
			Shopify.getCart(function(cart) {
              	bourdon.doUpdateDropdownCart(cart);
            });
        },
      
        dropdownSearch: function() {
			var iconSearch = $('.header-panel-top .icon-search');
            var closedSearch = $('.header-panel-top .close-search');          	

            if(iconSearch.is(':visible')) {
                iconSearch.off('click.showSearch').on('click.showSearch', function(e) {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  var height = $('.site-header').outerHeight();
          
                  if(body.hasClass('fixed-top') && $('.header-bottom').hasClass('fadeInDown')) {
                    var height = $('body.fixed-top .header-bottom').outerHeight();
                  }

                  $('.header-bottom .search-bar').css({'height': height});

                  $(this).next('').addClass('search_open');
//                   $(this).next('').find('.input-group-field').focus();
                });

                doc.off('click.closedSearch').on('click.closedSearch', function(e) {
                    if (!$(e.target).closest('form.search-bar').length && $('form.search-bar').hasClass('search_open')) {
                      closedSearch.trigger('click');
                    }        
                });
            };

            closedSearch.off('click.closedSearch').on('click.closedSearch', function(e) {
                  e.preventDefault();
                  e.stopPropagation();

                  $(this).closest('form.search-bar').removeClass('search_open');
            });
        },
      
      	initDropdownUser: function() {
        	var iconUser = $('.header-panel-top .user-icon');

            if(iconUser.is(':visible')) {
              iconUser.off('click.toogleDropdownCustomerLink').on('click.toogleDropdownCustomerLink', function(e) {
                  e.preventDefault();
                  e.stopPropagation();

                  $(this).next().slideToggle();
              });

              doc.off('click.closeDropdownUser').on('click.closeDropdownUser', function(e) {
                  if (!$(e.target).closest('.customer-links').length && $('.customer-links').is(':visible')) {
                    iconUser.trigger('click');
                  }        
              });
            };
        },
      
        addClassChangeMegaMenuBackground: function() {
			if(window.innerWidth > 991) {
              var megaMenuItem = $('.site-nav > li');
              
              if(!('ontouchstart' in document)) {
                megaMenuItem.hover(function() {
                  if ($('.site-nav > li.dropdown > .site-nav-dropdown').is(':visible')) {
                    if($(this).hasClass('mega-menu')) {
                      $(this).closest('.nav-bar-mobile').css({'background-color': '#fff'});
                    }
                    
                    $('.lang-block .selectize-dropdown').hide();
                    $('.currency .selectize-dropdown').hide();
                    $('#dropdown-cart').hide();
                    $('.header-customer-links .customer-links').hide();
                  }
                  else {
                    $(this).closest('.nav-bar-mobile').css({'background-color': ''});
                  };
                });
              }
            };
        },
      
        initProductAddToCart: function() {
			var btnAddToCart = $('#product-add-to-cart');
    
            if(btnAddToCart.length) {
                btnAddToCart.off('click.addToCartProduct').on('click.addToCartProduct', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if($(this).attr('disabled') != 'disabled') {
                        if(!window.ajax_cart) {
                            $(this).closest('form').submit();
                        }

                        else {
                            var variant_id = $('#add-to-cart-form select[name=id]').val();
                            if(!variant_id) {
                              variant_id = $('#add-to-cart-form input[name=id]').val();
                            }

                            var quantity = $('#add-to-cart-form input[name=quantity]').val();
                            if(!quantity) {
                              quantity = 1;
                            }

                            var title = $('.product-title h2').html();

                            var image = $('.slick-current img[id|="product-featured-image"]').attr('src') || $('.product img[id|="product-featured-image"]').attr('src');

                            bourdon.doAjaxAddToCart(variant_id, quantity, title, image);
                        }
                    }

                    return false;

                });
            }
        },
      
        initAddToCart: function() {
			var btnAddToCart = $('.add-to-cart-btn');
    
            if(btnAddToCart.length) {
              	body.off('click.addToCart', '.add-to-cart-btn').on('click.addToCart', '.add-to-cart-btn', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if($(this).attr('disabled') != 'disabled') {
                      	var productItem = $(this).parents('.product-item');
                        var productId = $(productItem).attr('id');
                      	productId = productId.match(/\d+/g);
                      
                        if(!window.ajax_cart) {
                            $('#product-actions-' + productId).submit();
                        }

                        else {
                            var variant_id = $('#product-actions-' + productId + ' select[name=id]').val();
                            if(!variant_id) {
                              variant_id = $('#product-actions-' + productId + ' input[name=id]').val();
                            }

                            var quantity = $('#product-actions-' + productId + ' input[name=quantity]').val();
                            if(!quantity) {
                              quantity = 1;
                            }

                            var title = $(productItem).find('.product-title').html();

                            var image = $(productItem).find('.product-grid-image img').attr('src');

                            bourdon.doAjaxAddToCart(variant_id, quantity, title, image);
                        }
                    }

                    return false;

                });
            }
        },
      
        doAjaxAddToCart: function(variant_id, quantity, title, image) {
			$.ajax({
                type: "post",
                url: "/cart/add.js",
                data: 'quantity=' + quantity + '&id=' + variant_id,
                dataType: 'json',

                beforeSend: function() {
                  bourdon.showLoading();
                },

                success: function(msg) {
                  bourdon.hideLoading();

                  $('.ajax-success-modal').find('.ajax-product-title').html(bourdon.translateText(title));
                  $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                  $('.ajax-success-modal').find('.btn-go-to-wishlist').hide();
                  $('.ajax-success-modal').find('.btn-go-to-cart').show();

                  bourdon.showModal('.ajax-success-modal');
                  bourdon.updateDropdownCart();
                },

                error: function(xhr, text) {
                  bourdon.hideLoading();

                  $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);

                  bourdon.showModal('.ajax-error-modal');
                }
            });
        },
      
//       	createRegex: function(price) {
//         	var strFormat = "amount_no_decimal";
//             var decimalNumber = price.split(/[.|,]/).length - 1;
//             var amountNumber = price.split(/[.|,]/).length - 2;

//             if(window.money_format.indexOf(strFormat) >= 0) {
//                 return new RegExp('(([0-9]+[,|.]){' + decimalNumber + '}[0-9]+)', 'g');
//             }

//             else {
//                 return new RegExp('(([0-9]+[,|.]){' + amountNumber + '}[0-9]+)', 'g');
//             };
//         },
      
        initQuickView: function() {
          	body.off('click.initQuickView', '.quickview-button a').on('click.initQuickView', '.quickview-button a', function(e) {
              e.preventDefault();
              e.stopPropagation();

              var product_handle = $(this).attr('id');

              Shopify.getProduct(product_handle, function(product) {
                  var template = $('#quickview-template').html();          
                  $('.quick-view').html(template);          
                  var quickview = $('.quick-view');


                  // -----  product-title
                  quickview.find('.product-title a').html(bourdon.translateText(product.title));

                  quickview.find('.product-title a').attr('href', product.url);

                  quickview.find('.product-title a').attr('title', bourdon.translateText(product.title));


                  //  ------ vendorLink
                  if (quickview.find('.product-vendor').length) {
                    quickview.find('.product-vendor span').text(product.vendor);
                  };


                  // -----------product type
                  if (quickview.find('.product-type').length) {
                    quickview.find('.product-type span').text(product.type);
                  };


                  // -----------product invetory
                  if (quickview.find('.product-inventory').length) {
                    var variant = product.variants[0];
                    var inventoryInfo = quickview.find('.product-inventory span');

                    if (variant.available) {
                      if (variant.inventory_management != null) {
                        inventoryInfo.text(window.inventory_text.in_stock);
                      }
                      else {
                        inventoryInfo.text(window.inventory_text.many_in_stock);
                      }
                    }

                    else {
                      inventoryInfo.text(window.inventory_text.out_of_stock);
                    }
                  };


                  // ----------  product Vendor 
                  if (quickview.find('.vendor-product').length) {
                    quickview.find('.vendor-product span').text(product.vendor);
                  };


                  //countdown for quickview
                  if (product.description.indexOf("[countdown]")) {
                    var countdownTime = product.description.match(/\[countdown\](.*)\[\/countdown\]/);

                    if (countdownTime && countdownTime.length > 0) {
                      quickview.find(".countdown").show();

                      quickview.find(".quickview-clock").countdown(countdownTime[1], function(event) {
                        $(this).html(event.strftime('%Dd %H:%M:%S'));
                      });
                    }
                  };


                  // -----------product description
                  if (quickview.find('.short-description').length) {
                    var description = product.description.replace(/(<([^>]+)>)/ig, "");
                    var description = description.replace(/\[countdown\](.*)\[\/countdown\]/g, "");

                    if (window.multi_lang) {
                      if (description.indexOf("[lang2]") > 0) {
                        var descList = description.split("[lang2]");

                        if (jQuery.cookie("language") != null) {
                          description = descList[translator.current_lang - 1];
                        }
                        else {
                          description = descList[0];
                        }
                      }
                    };

                    description = description.split(" ").splice(0, 20).join(" ") + "...";
                    quickview.find('.short-description').text(description);
                  }

                  else {
                    quickview.find('.short-description').remove();
                  };


                  // -------product price
                  var quickViewPriceElm = quickview.find('.price');
                  var productPrice = product.price;

                  if (window.money_format.indexOf('{{amount_no_decimals}}') >= 0) {
                    productPrice *= 100;
                  }

                  quickViewPriceElm.html(Shopify.formatMoney(productPrice, window.money_format));


                  // -----------if has compare price
                  var quickViewComparePriceElm = quickview.find('.compare-price');
                  var comparePrice = product.compare_at_price_max;

                  if (product.compare_at_price > product.price) {

                    if (window.money_format.indexOf('{{amount_no_decimals}}') >= 0) {
                      comparePrice *= 100;
                    }

                    quickViewComparePriceElm.html(Shopify.formatMoney(comparePrice, window.money_format)).show();

                    quickViewPriceElm.addClass('on-sale');
                  }

                  else {
                    quickViewComparePriceElm.html('');
                    quickViewPriceElm.removeClass('on-sale');
                  }


                  // -----------id product 
                  quickview.find('.product-item').attr('id', 'product-' + product.id);
                  quickview.find('.variants').attr('id', 'product-actions-' + product.id);
                  quickview.find('.variants select').attr('id', 'product-select-' + product.id);


                  //out of stock
                  if (!product.available) {
                    quickview.find("select, input, .total-price, .des, .inc, .variants label").remove();
                    quickview.find(".add-to-cart-btn").text(window.inventory_text.unavailable).addClass('disabled').attr("disabled", "disabled");;
                  }

                  else {
                    var quickViewTotalPriceElm = quickview.find('.total-price span');
                    var productPrice = product.price;

                    if(window.money_format.indexOf('{{amount_no_decimals}}') >= 0) {
                      productPrice *= 100;
                    }

                    quickViewTotalPriceElm.html(Shopify.formatMoney(productPrice, window.money_format));


                    // ------------swatch
                    if (window.use_color_swatch) {
                      bourdon.createQuickViewVariantsSwatch(product, quickview);
                    }
                    else {
                      bourdon.createQuickViewVariants(product, quickview);
                    }
                  };


                  //quantity
                  quickview.find('.button').off('click.changeQtt').on('click.changeQtt', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var oldValue = quickview.find(".quantity").val(),
                        newVal = 1;

                    if($(this).hasClass('inc')) {
                      newVal = parseInt(oldValue) + 1;
                    }
                    else if(oldValue > 1) {
                      newVal = parseInt(oldValue) - 1;
                    }

                    quickview.find('.quantity').val(newVal);

                    if (quickview.find('.total-price').length) {
                      bourdon.updatePricingQuickview();
                    }
                  });

                  if (window.show_multiple_currencies) {
                    Currency.convertAll(window.shop_currency, $('#currencies').val(), 'span.money', 'money_format');
                  }

                  bourdon.loadQuickViewSlider(product, quickview);
                  bourdon.initQuickviewAddToCart();
                  bourdon.translateBlock('.quick-view');                    

                  $('.quick-view').fadeIn(500);

                  if ($('.quick-view .total-price').length > 0) {
                    $('.quick-view input[name=quantity]').on('change', bourdon.updatePricingQuickview);
                  }
                });

              return false;

          });
          
            doc.off('click.closeQuickView').on('click.closeQuickView', '.quick-view .overlay, .close-window', function() {
				bourdon.closeQuickViewPopup();
                return false;
            });
        },
      
        convertToSlug: function(text) {
			return text
            .toLowerCase()
            .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');
        },
      
        createQuickViewVariantsSwatch: function(product, quickviewTemplate) {
			//multiple variants	
            if (product.variants.length > 1) {
              for (var i = 0; i < product.variants.length; i++) {
                var variant = product.variants[i];
                var option = '<option value="' + variant.id + '">' + variant.title + '</option>';

                quickviewTemplate.find('form.variants > select').append(option);
              }


              new Shopify.OptionSelectors("product-select-" + product.id, {
                product: product,
                onVariantSelected: selectCallbackQuickview
              });


              //start of quickview variant;
              var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
              var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
              var options = "";

              for (var i = 0; i < product.options.length; i++) {
                options += '<div class="swatch clearfix" data-option-index="' + i + '">';
                options += '<div class="header">' + product.options[i].name + '</div>';

                var is_color = false;

                if (/Color|Colour/i.test(product.options[i].name)) {
                  is_color = true;
                };

                var optionValues = new Array();

                for (var j = 0; j < product.variants.length; j++) {
                  var variant = product.variants[j];
                  var value = variant.options[i];
                  var valueHandle = bourdon.convertToSlug(value) || value;
                  var forText = 'swatch-' + i + '-' + valueHandle;

                  if (optionValues.indexOf(value) < 0) {
                    //not yet inserted
                    options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';

                    if (is_color) {
                      options += '<div class="tooltip">' + value + '</div>';
                    }
                    options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';

                    if (is_color) {
                      options += '<label for="' + forText + '" style="background-color: ' + valueHandle + '; background-image: url(' + filePath + valueHandle + '.png)"><span class="crossed-out"></span></label>';
                    }
                    else {
                      options += '<label for="' + forText + '">' + value + '<span class="crossed-out"></span></label>';
                    }
                    options += '</div>';
                    if (variant.available) {
                      $('.quick-view .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                    }
                    optionValues.push(value);
                  };
                };
                options += '</div>';
              };

              quickviewTemplate.find('form.variants > select').after(options);
              
              changeSwatch(quickviewTemplate.find('.swatch :radio'));
              
              if (product.available) {
//                 Shopify.optionsMap = {};
                Shopify.quickViewOptionsMap = {};
                Shopify.linkOptionSelectors(product, '.quick-view');
              }
            }


            //single variant
            else {
              quickviewTemplate.find('form.variants > select').remove();
              var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
              quickviewTemplate.find('form.variants').append(variant_field);
            };
        },
      
        createQuickViewVariants: function(product, quickviewTemplate) {
			//multiple variants
            if (product.variants.length > 1) { 
              for (var i = 0; i < product.variants.length; i++) {
                var variant = product.variants[i];
                var option = '<option value="' + variant.id + '">' + variant.title + '</option>';

                quickviewTemplate.find('form.variants > select').append(option);
              }

              new Shopify.OptionSelectors("product-select-" + product.id, {
                product: product,
                onVariantSelected: selectCallbackQuickview
              });

              if (product.options.length == 1) {
                $('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');

                for (var text = product.variants, r = 0; r < text.length; r++ ) {
                  var s = text[r];

                  if (!s.available) {
                    $('.single-option-selector option').filter(function() {
                      return $(this).html() === s.title 
                    }).remove();
                  }
                };
              };

              $('.quick-view .single-option-selector').selectize();
              $('.quick-view .selectize-input input').attr("disabled", "disabled");

              quickviewTemplate.find('form.variants .selector-wrapper label').each(function(i,v) {
                $(this).html(product.options[i].name);
              });
            }

            //single variant
            else { 
              quickviewTemplate.find('form.variants > select').remove();

              var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';

              quickviewTemplate.find('form.variants').append(variant_field);
            };
        },
      
        updatePricingQuickview: function() {
            var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
            var unitPriceTextMatch = $('.quick-view .price').text().match(regex);

            if (!unitPriceTextMatch) {
              regex = /([0-9]+[.|,][0-9]+)/g;
              unitPriceTextMatch = $('.quick-view .price').text().match(regex);
            }

            if (unitPriceTextMatch) {
              var unitPriceText = unitPriceTextMatch[0];
              var unitPrice = unitPriceText.replace(/[.|,]/g, '');
              var quantity = parseInt($('.quick-view input[name=quantity]').val());
              var totalPrice = unitPrice * quantity;

              var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
              regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
              if (!totalPriceText.match(regex)) {
                regex = /([0-9]+[.|,][0-9]+)/g;
              } 
              totalPriceText = totalPriceText.match(regex)[0];

              var regInput = new RegExp(unitPriceText, "g");
              var totalPriceHtml = $('.quick-view .price').html().replace(regInput, totalPriceText);

              $('.quick-view .total-price span').html(totalPriceHtml);
            };
          
// 			var regex = bourdon.createRegex($('.quick-view .price').text());
//             var unitPriceTextMatch = $('.quick-view .price').text().match(regex);

//             if (unitPriceTextMatch) {
//               var unitPriceText = unitPriceTextMatch[0];
//               var unitPrice = unitPriceText.replace(/[.|,]/g, '');
//               var quantity = parseInt($('.quick-view input[name=quantity]').val());
//               var totalPrice = unitPrice * quantity;
//               var totalPriceText = Shopify.formatMoney(totalPrice * 100, window.money_format);
//               var regex = bourdon.createRegex(totalPriceText);

//               totalPriceText = totalPriceText.match(regex)[0];

//               var regInput = new RegExp(unitPriceText, "g");
//               var totalPriceHtml = $('.quick-view .price').html().replace(regInput, totalPriceText);

//               $('.quick-view .total-price span').html(totalPriceHtml);
//             };
        },
      
        loadQuickViewSlider: function(product, quickviewTemplate) {
			var quickViewSliderFor = quickviewTemplate.find('.quickview-featured-image');
            var count = 0;

            for (i in product.images) {
              if (count < product.images.length) {
                var featuredImage = Shopify.resizeImage(product.images[i], '1024x1024');
                var thumb = '<div class="thumb"><a href="' + product.url + '" title="' + product.title + '"><img src="' + featuredImage + '"  /></a></div>'

                quickViewSliderFor.append(thumb);
                count = count + 1;
              }
            };

            var quickViewsliderNav = quickviewTemplate.find('.slider-nav');
            var count_2 = 0;

            for (i in product.images) {
              if (count_2 < product.images.length) {
                var original = Shopify.resizeImage(product.images[i], '1024x1024');
                var compact = Shopify.resizeImage(product.images[i], '64x64');
                var item = '<div class="item"><a href="javascript:void(0)" data-image="' + original + '"><img src="' + compact + '"  /></a></div>'

                quickViewsliderNav.append(item);
                count_2 = count_2 + 1;
              }
            };

            clearTimeout(bourdon.bourdonTimeout);

            var counter = 0;
            var imgTags = quickviewTemplate.find('.quickview-featured-image img, .slider-nav img');

            imgTags.on('load', function() {
              counter++;

              if (counter === imgTags.length) {

                bourdon.bourdonTimeout = setTimeout(function() {
                  bourdon.initHorizontallMoreview(quickViewSliderFor, quickViewsliderNav);
                }, 300);

              }
            });
        },
      
      	initQuickviewAddToCart: function() {
        	if ($('.quick-view .add-to-cart-btn').length) {
              $('.quick-view .add-to-cart-btn').off('click.quickViewAddToCart').on('click.quickViewAddToCart', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var variant_id = $('.quick-view select[name=id]').val();

                if (!variant_id) {
                  variant_id = $('.quick-view input[name=id]').val();
                };

                var quantity = $('.quick-view input[name=quantity]').val();
                if (!quantity) {
                  quantity = 1;
                };

                var title = $('.quick-view .product-title a').html();
                var image = $('.quick-view .quickview-featured-image .slick-current img').attr('src') || $('.quick-view .quickview-featured-image img').attr('src');

                bourdon.doAjaxAddToCart(variant_id, quantity, title, image);
                bourdon.closeQuickViewPopup();
              });
            };
        },
      
        closeQuickViewPopup: function() {
          $('.quick-view').fadeOut(500);
        },
        
    }
})(jQuery);